import {BehaviorSubject} from 'rxjs';

export class Store<T> {
    protected observableValue: BehaviorSubject<T> = new BehaviorSubject(null);
    readonly observableValue$ = this.observableValue.asObservable();

    protected loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
    readonly loading$ = this.loading.asObservable();
}
